import { useMemo } from "react"

import { useGetOrderTypesQuery } from "store/api/dictionaryApi"
import { UITypes } from "types"

export const useOrderTypeOptions = (): UITypes.Option[] => {
  const { data } = useGetOrderTypesQuery()

  return useMemo(
    () =>
      (data?.data ?? []).map(item => ({
        label: item.description,
        value: item.value,
      })),
    [data],
  )
}
